export interface BrandingVariant {
  id: string;
  name: string;
  color: string; // For slider indicator
  colorSchemeName: string;
}

export const BRANDING_VARIANTS: BrandingVariant[] = [
  {
    id: 'classic',
    name: 'Classic',
    color: '#A8BF9E',
    colorSchemeName: 'CLASSIC',
  },
  {
    id: 'sunny',
    name: 'Sunny',
    color: '#FFD93D',
    colorSchemeName: 'SUNNY',
  },
  {
    id: 'dark',
    name: 'Dark',
    color: '#000000',
    colorSchemeName: 'DARK',
  },
  {
    id: 'pink',
    name: 'Pink',
    color: '#F4A9AE',
    colorSchemeName: 'PINK',
  },
  {
    id: 'sage-grey',
    name: 'Sage Grey',
    color: '#A8BFB5',
    colorSchemeName: 'SAGE_GREY',
  },
  {
    id: 'steel-blue',
    name: 'Steel Blue',
    color: '#5B8FB9',
    colorSchemeName: 'STEEL_BLUE',
  },
  {
    id: 'lilac',
    name: 'Lilac',
    color: '#C8A2C8',
    colorSchemeName: 'LILAC',
  },
  {
    id: 'mocha',
    name: 'Mocha',
    color: '#8B6F47',
    colorSchemeName: 'MOCHA',
  },
  {
    id: 'light-sage',
    name: 'Light Sage',
    color: '#A8BF9E',
    colorSchemeName: 'LIGHT_SAGE',
  },
  {
    id: 'terracotta',
    name: 'Terracotta Clay',
    color: '#C97064',
    colorSchemeName: 'TERRACOTTA_CLAY',
  },
  {
    id: 'blood-red',
    name: 'Blood Red',
    color: '#8C1C13',
    colorSchemeName: 'BLOOD_RED',
  },
  {
    id: 'forest-green',
    name: 'Forest Green',
    color: '#2D5A27',
    colorSchemeName: 'FOREST_GREEN',
  },
  {
    id: 'midnight-navy',
    name: 'Midnight Navy',
    color: '#1B3A6B',
    colorSchemeName: 'MIDNIGHT_NAVY',
  },
  {
    id: 'charcoal-steel',
    name: 'Charcoal Steel',
    color: '#1C1C1E',
    colorSchemeName: 'CHARCOAL_STEEL',
  },
  {
    id: 'deep-burgundy',
    name: 'Deep Burgundy',
    color: '#6B2737',
    colorSchemeName: 'DEEP_BURGUNDY',
  },
  {
    id: 'burnt-orange',
    name: 'Burnt Orange',
    color: '#C8511A',
    colorSchemeName: 'BURNT_ORANGE',
  },
];
